import Box from '@mui/material/Box'

interface OfferPackageTabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}
function CustomerTabPanel(props: OfferPackageTabPanelProps) {
  const { children, value, index, ...other } = props

  return (
    <div role='tabpanel' hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  )
}

export default CustomerTabPanel
